import Input from "../../../../components/Input/Input";

const Number = ({id, formik, settings = {}}) => {
    const inputElement = document.getElementById(id);

    if (inputElement) {
        inputElement.addEventListener('keypress', (e) => {
            if (isNaN(e.key))
                e.preventDefault();
        });
    }

    return (
        <Input
            name={id}
            label={settings.title}
            type="number"
            required={settings.required}
            description={settings.description}
            formik={formik}
            layout="vertical"
        />
    )
};

export default Number;